var _style, _ellipse, _ellipse2, _ellipse3, _ellipse4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCastaliaLoaderPerspective(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: 120,
    height: 120,
    fill: "none",
    role: "img",
    "aria-label": "Loading",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n.ring{transform-box:fill-box;transform-origin:center;opacity:0;animation:cx-expand 2.4s cubic-bezier(.2,.6,.3,1) infinite}\n.d2{animation-delay:.8s}.d3{animation-delay:1.6s}\n@keyframes cx-expand{0%{transform:scale(.08);opacity:1}100%{transform:scale(1);opacity:0}}\n@media (prefers-reduced-motion: reduce){.ring{animation:none;opacity:.8}.ring{transform:scale(.35)}.d2{transform:scale(.65);opacity:.5}.d3{transform:scale(1);opacity:.25}}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "ring",
    cx: 60,
    cy: 66,
    rx: 54,
    ry: 18,
    stroke: "#E84BFA",
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "ring d2",
    cx: 60,
    cy: 66,
    rx: 54,
    ry: 18,
    stroke: "#E84BFA",
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "ring d3",
    cx: 60,
    cy: 66,
    rx: 54,
    ry: 18,
    stroke: "#E84BFA",
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 66,
    rx: 4,
    ry: 1.6,
    fill: "#E84BFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastaliaLoaderPerspective);
export default __webpack_public_path__ + "static/media/castalia-loader-perspective.f0b04aed2bb27a312672fc9018f8d41e.svg";
export { ForwardRef as ReactComponent };